<template>
  <ul class="l-reset customer-list">
    <li>
      <input
        type="text"
        placeholder="Search customer"
        :value="searchVal"
        v-on:input="updateSearchVal"
      />
    </li>
    <li
      class="p-20"
      v-for="(x, index) in filteredCustomerList"
      :key="index"
      @click="() => props.clickCustomer(x)"
    >
      <customer-result-node :data="x" />
    </li>
  </ul>
</template>

<script>
import CustomerResultNode from "./CustomerResultNode";
import { filterObjectValues } from '../utils/filter'
export default {
  props: ["props"],
  components: { CustomerResultNode },
  name: "CustomerList",
  mounted: function() {
    if (!this.$store.getters.customerList.loaded) {
      this.$store.dispatch("loadCustomerList");
    }
  },
  data: () => ({
    searchVal: ""
  }),
  computed: {
    filteredCustomerList() {
      let list = [...this.$store.getters.customerList.data];
      list.reverse();
      return this.searchVal === "" || this.searchVal.length < 3
        ?  [...list].splice(0, 30)
        : filterObjectValues(list, this.searchVal, null)
    }
  },
  methods: {
    updateSearchVal(e) {
      this.searchVal = e.target.value;
    }
  }
};
</script>

<style lang="scss">
.customer-list {
  li {
    border-radius: 4px;
    padding: 6px 10px;
    width: calc(97% - 25px);
    margin: 0 auto;
    cursor: pointer;
    &:not(:first-child):hover {
      background-color: #ebebeb;
    }
    p {
      font-size: 0.9rem;
    }
    input[type="text"] {
      background-color: rgb(231, 231, 231);
      width: calc(100% - 20px);
      margin: 3px auto 10px auto;
      border-radius: 5px;
      box-shadow: 0 0 0 1px rgb(117, 197, 228);
      background-color: rgb(240, 251, 255);
    }
  }
}
</style>
